// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"e_Yf","pageSubTitle":"e_Zf"};